/** Public pages and participant chrome. Not SP-Wiki article text. Placeholders stay as {n}, {current}, {done}, {left}, {date}, {q}, {name}, {shown}, {total}. */
const landing = {
  'zh-TW': {
    footerDevelopedBy: '開發團隊',
    newsTitle: '新聞',
    newsSubtitle: 'SP-Survey 的產品更新、版本與研究筆記。',
    newsEmpty: '尚無文章，請稍後再來看。',
    newsBackToList: '全部新聞',
    newsNotFound: '找不到這篇文章，或它已不再公開。',
    newsNoBody: '沒有內容。',
    newsUnavailable: '新聞尚未開放。',
    benchViewLeaderboard: '查看排行榜',
    landGrowthTitle: '平台成長',
    landGrowthSubtitle: '平台即時累計數據，以及最近 12 個月的成長。僅平台管理員可見。',
    landGrowthUsers: '註冊研究者',
    landGrowthProjects: '問卷專案',
    landGrowthResponses: '已收集回答',
    landGrowthVisits: '近 30 天造訪',
    landGrowthTotalHint: '累計',
    landGrowthVisitorsHint: '獨立訪客 {n}（按天計）',
    landLiveBannerOne: '目前有 {n} 份調查正在進行 — 可作為參與者填寫。',
    landLiveBannerMany: '目前有 {n} 份調查正在進行 — 可作為參與者填寫。',
    landBrowseLive: '瀏覽線上調查',
    landHeroTitle: '街景感知調查',
    landHeroLine1: '面向城市街景視覺感知研究的專業調查平台。',
    landHeroLine2: '建立、分享並分析街景感知研究 — 無需程式設計。',
    landStartFree: '免費開始 →',
    landReadPaper: '閱讀論文',
    landFeaturesTitle: '感知研究所需的一切',
    landFeatUploadTitle: '上傳圖片',
    landFeatUploadDesc: '將街景圖片直接上傳到雲端儲存，並自動壓縮以保持問卷載入迅速。',
    landFeatAiTitle: 'AI 問卷建構',
    landFeatAiDesc: '描述研究目標，由 ChatGPT 產生完整問卷，並使用經過驗證的題型。',
    landFeatShareTitle: '即時分享',
    landFeatShareDesc: '立即取得可分享連結 — 無需伺服器、無需部署、無需複雜設定。',
    landFeatResultsTitle: '結果分析',
    landFeatResultsDesc: '按題目查看答卷，支援圖片與回答配對，並可匯出 CSV。',
    landTemplatesTitle: '模板庫',
    landTemplatesSubtitle: '從已發表研究中使用的同儕審查問卷設計開始',
    landRequestTemplate: '為你的論文申請模板',
    landRequestDesign: '申請問卷設計協助',
    landSearchTemplates: '按名稱、作者或主題搜尋模板…',
    landCatAcademic: '學術研究',
    landCatUrban: '城市理論',
    landCatAi: 'AI 生成',
    landSearchCategoryHint: '搜尋以瀏覽此類別全部 {n} 個模板。',
    landNoTemplates: '找不到與「{q}」相符的模板',
    landCtaTitle: '準備好開始你的調查了嗎？',
    landCtaBody: '建立帳號，10 分鐘內即可上線第一份問卷。',
    landGetStarted: '免費開始',
    landPreview: '預覽',
    landUse: '使用',
    landPaper: '論文',
    landDataset: '資料集',
    landChipAi: 'AI',
    landChipUrban: '城市',
    landChipAcademic: '學術',
    landPreviewTitle: '預覽 — {name}',
    landReadOnly: '（唯讀）',
    landClose: '關閉',
    trialDoNTimes: '本題將進行 {n} 次。這是第 {current} 次，共 {n} 次。',
    trialProgressCount: '已完成 {done} / {n}。還剩 {left}。',
    trialAutoAdvance: '作答後，下一輪會自動開始。',
    trialAutoAdvanceAllocation: '每個選項都設好，或點數用完後，會自動進入下一輪。若想留有剩餘點數，請點「下一輪」。',
    trialUseNext: '回答後請按「下一輪」。',
    trialLastRound: '最後一輪 — 之後繼續問卷。',
    trialAllDone: '{n} 輪都已回答。',
    trialContinue: '前往下一題',
    trialFinishSurvey: '完成問卷',
    trialBack: '返回',
    trialNextRound: '下一輪',
    trialPageNextBlocked: '請先完成所有輪次再繼續。',
    progressRound: '第 {current} / {n} 輪',
    trialLabel: '第 {n} 輪',
    trialReviewAnswers: '查看回答',
    progressPage: '第 {current} / {n} 頁',
    progressQuestion: '第 {current} / {n} 題',
    progressQuestionLabel: '第 {n} 題',
    progressTrialCount: '{done}/{n} 輪',
    progressNotReached: '尚未到達',
    progressJump: '{label} — 點擊跳轉',
    progressPreviousGroup: '上一組題目',
    progressNextGroup: '下一組題目',
    participantSaving: '正在儲存你的回答…',
    participantThanks: '謝謝！',
    participantCompleted: '感謝你完成本次調查！',
    participantRoundsCompleted: '全部 {n} 輪標註已完成！',
    participantCompletionCode: '完成代碼：',
    participantIdLabel: '你的參與者 ID：',
    participantSavedLocally: '回答已儲存在本機。',
    participantSaved: '回答已成功儲存。',
    participantSaveError: '因為網路或伺服器問題，未能儲存回答。你的答案仍保留著 — 請再試一次。',
    participantRetrySubmission: '重新提交',
    participantResumeTitle: '要繼續上次未完成的調查嗎？',
    participantResumeBody: '找到一份來自 {date} 的未完成調查。要從上次停下的地方繼續嗎？',
    participantPreviousVisit: '先前的造訪',
    participantStartFresh: '重新開始',
    participantResume: '繼續',
    loginBrand: '街景感知調查',
    loginSubtitle: '研究者登入',
    loginSignIn: '登入',
    loginCreateAccount: '建立帳號',
    loginEmail: '電子郵件',
    loginPassword: '密碼',
    loginPasswordHelp: '至少 6 個字元',
    loginSigningIn: '正在登入…',
    loginCreating: '正在建立帳號…',
    loginRegisterSuccess: '註冊成功！請查收電子郵件以確認帳號，然後登入。',
    loginErrorGeneric: '發生錯誤',
    loginBackHome: '← 回到首頁',
    liveTitle: '線上調查',
    liveBody: '平台目前展示的社群研究。參與者連結依研究者的發布設定。灰色卡片不在核准的時間範圍內。',
    liveEmpty: '尚未有展示中的線上調查。研究者可從專案選單申請發布到首頁；管理員在管理後台核准。',
    liveNowOnline: '正在進行（{n}）',
    liveUpcomingClosed: '即將開始與已結束',
    liveOnline: '進行中',
    liveUpcoming: '即將開始',
    liveClosed: '已結束',
    liveNoDescription: '沒有提供說明。',
    liveTakeSurvey: '填寫調查',
    liveNotOpenYet: '尚未開放',
    teamTitle: '團隊',
    teamIntroBefore: 'SP-Survey 由',
    teamIntroMid: '領導，單位為',
    teamIntroAfter: '，新加坡國立大學，並與合作機構共同進行，由 Filip Biljecki 指導。',
    teamCollaborators: '合作者',
    teamAffiliations: '所屬機構',
    teamProfile: '個人頁',
    teamProjectLead: '計畫主持人',
    teamPI: '首席研究員',
    teamLeadBlurb: '發起並領導 SP-Survey 的設計、開發與開放發布，涵蓋平台架構、問卷工具與研究流程。',
    teamPiBlurb: 'Urban Analytics Lab 創辦人，為 SP-Survey 提供學術指導與研究方向。',
    teamRolePhd: '博士研究員',
    teamRoleEngineer: '研究工程師',
    teamRoleFellow: '研究員',
    teamRoleVisiting: '訪問學者',
    teamRoleAssocProf: '副教授',
    papersTitle: '論文庫',
    papersCount: '{n} 篇論文',
    papersWithTemplate: '{n} 篇有模板',
    papersWithTemplateTitle: '只顯示已連結調查模板的論文',
    papersBody: '整理城市影像與人類調查文獻，作為本平台問卷模板的依據。管理員將論文對應到既有模板後，會顯示模板 ID。',
    papersAll: '全部論文',
    papersHasTemplate: '有模板（{n}）',
    papersNoTemplate: '無模板（{n}）',
    papersSearchPlaceholder: '標題 / DOI / 期刊 / 作者 / 模板 ID',
    papersSearch: '搜尋',
    papersClearSearch: '清除搜尋',
    papersShowing: '顯示 {shown} / {total} 篇論文',
    papersHasTemplateSuffix: ' · 有模板',
    papersNoTemplateSuffix: ' · 無模板',
    papersNoMatch: '沒有相符的論文。',
    papersOpen: '開啟論文',
    papersColTitle: '標題',
    papersColYear: '年份',
    papersColTemplate: '模板',
    papersColLink: '連結',
  },
  ja: {
    footerDevelopedBy: '開発',
    newsTitle: 'ニュース',
    newsSubtitle: 'SP-Survey の更新、リリース、研究ノート。',
    newsEmpty: 'まだ記事がありません。',
    newsBackToList: 'すべてのニュース',
    newsNotFound: 'この記事は見つからないか、公開を終了しています。',
    newsNoBody: '内容がありません。',
    newsUnavailable: 'ニュースはまだ利用できません。',
    benchViewLeaderboard: 'ランキングを見る',
    landLiveBannerOne: '公開中の調査が {n} 件あります。参加者として回答できます。',
    landLiveBannerMany: '公開中の調査が {n} 件あります。参加者として回答できます。',
    landBrowseLive: '公開中の調査を見る',
    landHeroTitle: '街路景観の知覚調査',
    landHeroLine1: '都市の街路景観に関する視覚知覚調査のための研究用プラットフォームです。',
    landHeroLine2: '街路景観の知覚研究を作成し、共有し、分析できます。プログラミングは不要です。',
    landStartFree: '無料ではじめる →',
    landReadPaper: '論文を読む',
    landFeaturesTitle: '知覚研究に必要なもの',
    landFeatUploadTitle: '画像をアップロード',
    landFeatUploadDesc: '街路画像をクラウドに直接アップロードします。調査が軽くなるよう自動で圧縮します。',
    landFeatAiTitle: 'AI 調査ビルダー',
    landFeatAiDesc: '研究目的を書くと、ChatGPT が検証済みの質問タイプで調査を作成します。',
    landFeatShareTitle: 'すぐ共有',
    landFeatShareDesc: '共有リンクをすぐに取得できます。サーバー準備やデプロイは不要です。',
    landFeatResultsTitle: '結果の分析',
    landFeatResultsDesc: '質問ごとの回答を画像と対応づけて確認し、CSV に書き出せます。',
    landTemplatesTitle: 'テンプレート集',
    landTemplatesSubtitle: '発表済み研究で使われた査読済みの調査設計から始められます',
    landRequestTemplate: '論文向けテンプレートを依頼',
    landRequestDesign: '調査設計の支援を依頼',
    landSearchTemplates: '名前、著者、トピックで検索…',
    landCatAcademic: '学術研究',
    landCatUrban: '都市理論',
    landCatAi: 'AI 生成',
    landSearchCategoryHint: '検索すると、この分類の {n} 件をすべて見られます。',
    landNoTemplates: '「{q}」に一致するテンプレートはありません',
    landCtaTitle: '調査を始めますか？',
    landCtaBody: 'アカウントを作ると、10 分以内に最初の調査を公開できます。',
    landGetStarted: '無料ではじめる',
    landPreview: 'プレビュー',
    landUse: '使う',
    landPaper: '論文',
    landDataset: 'データセット',
    landChipAi: 'AI',
    landChipUrban: '都市',
    landChipAcademic: '学術',
    landPreviewTitle: 'プレビュー — {name}',
    landReadOnly: '（閲覧のみ）',
    landClose: '閉じる',
    trialDoNTimes: 'これは {n} 回行います。いま {current} / {n} 回目です。',
    trialProgressCount: '完了 {done} / {n}。残り {left}。',
    trialAutoAdvance: '回答すると、次の回が自動で始まります。',
    trialUseNext: '回答したあと「次の回」を押してください。',
    trialLastRound: '最後の回です。その後、調査を続けます。',
    trialAllDone: '{n} 回すべて回答しました。',
    trialContinue: '次の質問へ',
    trialFinishSurvey: '調査を終える',
    trialBack: '戻る',
    trialNextRound: '次の回',
    trialPageNextBlocked: '続ける前に、すべての回を完了してください。',
    progressRound: '回 {current} / {n}',
    trialLabel: '第 {n} 回',
    trialReviewAnswers: '回答を確認',
    progressPage: 'ページ {current} / {n}',
    progressQuestion: '質問 {current} / {n}',
    progressQuestionLabel: '質問 {n}',
    progressTrialCount: '{done}/{n} 回',
    progressNotReached: '未到達',
    progressJump: '{label} — クリックで移動',
    progressPreviousGroup: '前の質問グループ',
    progressNextGroup: '次の質問グループ',
    participantSaving: '回答を保存しています…',
    participantThanks: 'ありがとうございました',
    participantCompleted: '調査へのご協力ありがとうございました。',
    participantRoundsCompleted: '注釈 {n} 回をすべて完了しました。',
    participantCompletionCode: '完了コード：',
    participantIdLabel: '参加者 ID：',
    participantSavedLocally: '回答をこの端末に保存しました。',
    participantSaved: '回答を保存しました。',
    participantSaveError: 'ネットワークまたはサーバーの問題で保存できませんでした。回答は残っています。もう一度お試しください。',
    participantRetrySubmission: '再送信',
    participantResumeTitle: '前回の続きから再開しますか？',
    participantResumeBody: '{date} の未完了の調査が見つかりました。続きから始めますか？',
    participantPreviousVisit: '以前の訪問',
    participantStartFresh: '最初から',
    participantResume: '再開',
    loginBrand: '街路景観の知覚調査',
    loginSubtitle: '研究者ログイン',
    loginSignIn: 'ログイン',
    loginCreateAccount: 'アカウント作成',
    loginEmail: 'メール',
    loginPassword: 'パスワード',
    loginPasswordHelp: '6 文字以上',
    loginSigningIn: 'ログインしています…',
    loginCreating: 'アカウントを作成しています…',
    loginRegisterSuccess: '登録しました。確認メールを見てからログインしてください。',
    loginErrorGeneric: 'エラーが発生しました',
    loginBackHome: '← ホームへ',
    liveTitle: '公開中の調査',
    liveBody: 'プラットフォームが紹介している研究です。参加リンクは研究者の公開設定に従います。灰色のカードは公開期間外です。',
    liveEmpty: '紹介中の調査はまだありません。研究者はプロジェクトメニューからメインページへの公開を申請でき、管理者が承認します。',
    liveNowOnline: '公開中（{n}）',
    liveUpcomingClosed: '開始前と終了',
    liveOnline: '公開中',
    liveUpcoming: '開始前',
    liveClosed: '終了',
    liveNoDescription: '説明はありません。',
    liveTakeSurvey: '調査に回答',
    liveNotOpenYet: 'まだ開始していません',
    teamTitle: 'チーム',
    teamIntroBefore: 'SP-Survey は',
    teamIntroMid: 'が率い、所属は',
    teamIntroAfter: '（シンガポール国立大学）です。協力機関と共同で進めており、Filip Biljecki が指導しています。',
    teamCollaborators: '協力者',
    teamAffiliations: '所属',
    teamProfile: 'プロフィール',
    teamProjectLead: 'プロジェクトリード',
    teamPI: '主任研究者',
    teamLeadBlurb: 'SP-Survey の設計、開発、公開を主導しています。',
    teamPiBlurb: 'Urban Analytics Lab の創設者。SP-Survey の研究指導を行っています。',
    teamRolePhd: '博士研究員',
    teamRoleEngineer: 'リサーチエンジニア',
    teamRoleFellow: '研究員',
    teamRoleVisiting: '客員研究者',
    teamRoleAssocProf: '准教授',
    papersTitle: '論文ライブラリ',
    papersCount: '{n} 件の論文',
    papersWithTemplate: 'テンプレートあり {n}',
    papersWithTemplateTitle: '調査テンプレートに結びついた論文だけを表示',
    papersBody: 'このプラットフォームの調査テンプレートの根拠となる、都市画像と人の調査に関する文献です。管理者が論文とテンプレートを対応づけると、テンプレート ID が表示されます。',
    papersAll: 'すべての論文',
    papersHasTemplate: 'テンプレートあり（{n}）',
    papersNoTemplate: 'テンプレートなし（{n}）',
    papersSearchPlaceholder: '題名 / DOI / 掲載先 / 著者 / テンプレート ID',
    papersSearch: '検索',
    papersClearSearch: '検索をクリア',
    papersShowing: '{shown} / {total} 件を表示',
    papersHasTemplateSuffix: ' · テンプレートあり',
    papersNoTemplateSuffix: ' · テンプレートなし',
    papersNoMatch: '一致する論文がありません。',
    papersOpen: '論文を開く',
    papersColTitle: '題名',
    papersColYear: '年',
    papersColTemplate: 'テンプレート',
    papersColLink: 'リンク',
  },
  ko: {
    footerDevelopedBy: '개발',
    newsTitle: '뉴스',
    newsSubtitle: 'SP-Survey의 제품 업데이트, 릴리스, 연구 노트.',
    newsEmpty: '아직 글이 없습니다.',
    newsBackToList: '모든 뉴스',
    newsNotFound: '이 글을 찾을 수 없거나 더 이상 공개되지 않습니다.',
    newsNoBody: '내용이 없습니다.',
    newsUnavailable: '뉴스를 아직 사용할 수 없습니다.',
    benchViewLeaderboard: '순위 보기',
    landLiveBannerOne: '진행 중인 조사가 {n}건 있습니다. 참여자로 응답할 수 있습니다.',
    landLiveBannerMany: '진행 중인 조사가 {n}건 있습니다. 참여자로 응답할 수 있습니다.',
    landBrowseLive: '진행 중인 조사 보기',
    landHeroTitle: '가로 경관 지각 조사',
    landHeroLine1: '도시 가로 경관의 시각 지각 조사를 위한 연구용 플랫폼입니다.',
    landHeroLine2: '가로 경관 지각 연구를 만들고, 공유하고, 분석합니다. 프로그래밍은 필요하지 않습니다.',
    landStartFree: '무료로 시작 →',
    landReadPaper: '논문 읽기',
    landFeaturesTitle: '지각 연구에 필요한 기능',
    landFeatUploadTitle: '이미지 업로드',
    landFeatUploadDesc: '가로 이미지를 클라우드에 직접 올립니다. 설문이 빠르게 열리도록 자동으로 압축합니다.',
    landFeatAiTitle: 'AI 설문 작성',
    landFeatAiDesc: '연구 목표를 적으면 ChatGPT가 검증된 문항 유형으로 설문을 만듭니다.',
    landFeatShareTitle: '바로 공유',
    landFeatShareDesc: '공유 링크를 바로 받습니다. 서버 준비나 배포는 필요하지 않습니다.',
    landFeatResultsTitle: '결과 분석',
    landFeatResultsDesc: '문항별 응답을 이미지와 짝지어 보고 CSV로 내보낼 수 있습니다.',
    landTemplatesTitle: '템플릿 라이브러리',
    landTemplatesSubtitle: '발표된 연구에서 쓰인 동료 심사 설문 설계에서 시작합니다',
    landRequestTemplate: '논문용 템플릿 요청',
    landRequestDesign: '설문 설계 도움 요청',
    landSearchTemplates: '이름, 저자, 주제로 검색…',
    landCatAcademic: '학술 연구',
    landCatUrban: '도시 이론',
    landCatAi: 'AI 생성',
    landSearchCategoryHint: '검색하면 이 분류의 템플릿 {n}개를 모두 볼 수 있습니다.',
    landNoTemplates: '"{q}"와 맞는 템플릿이 없습니다',
    landCtaTitle: '조사를 시작할까요?',
    landCtaBody: '계정을 만들면 10분 안에 첫 설문을 열 수 있습니다.',
    landGetStarted: '무료로 시작',
    landPreview: '미리보기',
    landUse: '사용',
    landPaper: '논문',
    landDataset: '데이터셋',
    landChipAi: 'AI',
    landChipUrban: '도시',
    landChipAcademic: '학술',
    landPreviewTitle: '미리보기 — {name}',
    landReadOnly: '(읽기 전용)',
    landClose: '닫기',
    trialDoNTimes: '이것은 {n}번 합니다. 지금 {current} / {n}번째입니다.',
    trialProgressCount: '완료 {done} / {n}. 남은 횟수 {left}.',
    trialAutoAdvance: '응답하면 다음 회가 자동으로 시작됩니다.',
    trialUseNext: '응답한 뒤 「다음 회」를 누르세요.',
    trialLastRound: '마지막 회입니다. 이후 설문을 계속합니다.',
    trialAllDone: '{n}회를 모두 응답했습니다.',
    trialContinue: '다음 문항으로',
    trialFinishSurvey: '설문 끝내기',
    trialBack: '뒤로',
    trialNextRound: '다음 회',
    trialPageNextBlocked: '계속하기 전에 모든 회를 완료하세요.',
    progressRound: '회 {current} / {n}',
    trialLabel: '{n}회',
    trialReviewAnswers: '응답 보기',
    progressPage: '페이지 {current} / {n}',
    progressQuestion: '문항 {current} / {n}',
    progressQuestionLabel: '문항 {n}',
    progressTrialCount: '{done}/{n}회',
    progressNotReached: '아직 도달하지 않음',
    progressJump: '{label} — 클릭하여 이동',
    progressPreviousGroup: '이전 문항 묶음',
    progressNextGroup: '다음 문항 묶음',
    participantSaving: '응답을 저장하는 중…',
    participantThanks: '감사합니다',
    participantCompleted: '조사에 참여해 주셔서 감사합니다.',
    participantRoundsCompleted: '주석 {n}회를 모두 완료했습니다.',
    participantCompletionCode: '완료 코드:',
    participantIdLabel: '참여자 ID:',
    participantSavedLocally: '응답을 이 기기에 저장했습니다.',
    participantSaved: '응답을 저장했습니다.',
    participantSaveError: '네트워크 또는 서버 문제로 저장하지 못했습니다. 응답은 남아 있습니다. 다시 시도하세요.',
    participantRetrySubmission: '다시 제출',
    participantResumeTitle: '이전 조사를 이어서 할까요?',
    participantResumeBody: '{date}의 끝나지 않은 조사를 찾았습니다. 멈춘 곳에서 계속할까요?',
    participantPreviousVisit: '이전 방문',
    participantStartFresh: '처음부터',
    participantResume: '이어하기',
    loginBrand: '가로 경관 지각 조사',
    loginSubtitle: '연구자 로그인',
    loginSignIn: '로그인',
    loginCreateAccount: '계정 만들기',
    loginEmail: '이메일',
    loginPassword: '비밀번호',
    loginPasswordHelp: '6자 이상',
    loginSigningIn: '로그인 중…',
    loginCreating: '계정을 만드는 중…',
    loginRegisterSuccess: '등록되었습니다. 확인 메일을 본 뒤 로그인하세요.',
    loginErrorGeneric: '오류가 발생했습니다',
    loginBackHome: '← 홈으로',
    liveTitle: '진행 중인 조사',
    liveBody: '플랫폼이 소개하는 연구입니다. 참여 링크는 연구자의 공개 설정을 따릅니다. 회색 카드는 공개 기간 밖입니다.',
    liveEmpty: '소개 중인 조사가 아직 없습니다. 연구자는 프로젝트 메뉴에서 메인 페이지 공개를 신청하고, 관리자가 승인합니다.',
    liveNowOnline: '진행 중 ({n})',
    liveUpcomingClosed: '시작 전과 종료',
    liveOnline: '진행 중',
    liveUpcoming: '시작 전',
    liveClosed: '종료',
    liveNoDescription: '설명이 없습니다.',
    liveTakeSurvey: '조사 참여',
    liveNotOpenYet: '아직 열리지 않음',
    teamTitle: '팀',
    teamIntroBefore: 'SP-Survey는',
    teamIntroMid: '이 이끌며, 소속은',
    teamIntroAfter: ', 싱가포르국립대학교입니다. 협력 기관과 함께하며 Filip Biljecki가 지도합니다.',
    teamCollaborators: '협력자',
    teamAffiliations: '소속',
    teamProfile: '프로필',
    teamProjectLead: '프로젝트 리드',
    teamPI: '책임연구원',
    teamLeadBlurb: 'SP-Survey의 설계, 개발, 공개를 이끕니다.',
    teamPiBlurb: 'Urban Analytics Lab 설립자. SP-Survey의 연구 지도를 맡습니다.',
    teamRolePhd: '박사 연구원',
    teamRoleEngineer: '연구 엔지니어',
    teamRoleFellow: '연구원',
    teamRoleVisiting: '방문 연구원',
    teamRoleAssocProf: '부교수',
    papersTitle: '논문 라이브러리',
    papersCount: '논문 {n}편',
    papersWithTemplate: '템플릿 있음 {n}',
    papersWithTemplateTitle: '설문 템플릿과 연결된 논문만 보기',
    papersBody: '이 플랫폼의 설문 템플릿 근거가 되는 도시 이미지와 사람 대상 조사 문헌입니다. 관리자가 논문과 템플릿을 연결하면 템플릿 ID가 표시됩니다.',
    papersAll: '모든 논문',
    papersHasTemplate: '템플릿 있음 ({n})',
    papersNoTemplate: '템플릿 없음 ({n})',
    papersSearchPlaceholder: '제목 / DOI / 학술지 / 저자 / 템플릿 ID',
    papersSearch: '검색',
    papersClearSearch: '검색 지우기',
    papersShowing: '{shown} / {total}편 표시',
    papersHasTemplateSuffix: ' · 템플릿 있음',
    papersNoTemplateSuffix: ' · 템플릿 없음',
    papersNoMatch: '일치하는 논문이 없습니다.',
    papersOpen: '논문 열기',
    papersColTitle: '제목',
    papersColYear: '연도',
    papersColTemplate: '템플릿',
    papersColLink: '링크',
  },
  fi: {
    footerDevelopedBy: 'Kehittäjä',
    newsTitle: 'Uutiset',
    newsSubtitle: 'SP-Surveyn päivitykset, julkaisut ja tutkimushuomiot.',
    newsEmpty: 'Ei vielä julkaisuja.',
    newsBackToList: 'Kaikki uutiset',
    newsNotFound: 'Julkaisua ei löydy tai sitä ei enää näytetä.',
    newsNoBody: 'Ei sisältöä.',
    newsUnavailable: 'Uutiset eivät ole vielä käytettävissä.',
    benchViewLeaderboard: 'Näytä tulostaulukko',
    landLiveBannerOne: '{n} kysely on avoinna — voit vastata osallistujana.',
    landLiveBannerMany: '{n} kyselyä on avoinna — voit vastata osallistujana.',
    landBrowseLive: 'Selaa avoimia kyselyitä',
    landHeroTitle: 'Katunäkymien havaintokysely',
    landHeroLine1: 'Tutkimustason alusta kaupunkien katunäkymien visuaalisiin havaintokyselyihin.',
    landHeroLine2: 'Rakenna, jaa ja analysoi katunäkymien havaintotutkimuksia — ilman ohjelmointia.',
    landStartFree: 'Aloita maksutta →',
    landReadPaper: 'Lue artikkeli',
    landFeaturesTitle: 'Havaintotutkimuksen työkalut',
    landFeatUploadTitle: 'Lataa kuvia',
    landFeatUploadDesc: 'Lataa katunäkymät suoraan pilveen. Kuvat pakataan automaattisesti, jotta kysely pysyy nopeana.',
    landFeatAiTitle: 'Tekoälyavusteinen kysely',
    landFeatAiDesc: 'Kuvaa tutkimuksen tavoite. ChatGPT kokoaa kyselyn tarkistetuilla kysymystyypeillä.',
    landFeatShareTitle: 'Jaa heti',
    landFeatShareDesc: 'Saat jaettavan linkin heti. Palvelinta tai julkaisua ei tarvitse pystyttää.',
    landFeatResultsTitle: 'Tulosten analyysi',
    landFeatResultsDesc: 'Katso vastaukset kysymyksittäin, yhdistä ne kuviin ja vie CSV-tiedostoksi.',
    landTemplatesTitle: 'Mallikirjasto',
    landTemplatesSubtitle: 'Aloita vertaisarvioiduista kyselymalleista, joita on käytetty julkaistussa tutkimuksessa',
    landRequestTemplate: 'Pyydä mallia artikkelillesi',
    landRequestDesign: 'Pyydä apua kyselyn suunnitteluun',
    landSearchTemplates: 'Hae nimellä, tekijällä tai aiheella…',
    landCatAcademic: 'Akateeminen tutkimus',
    landCatUrban: 'Kaupunkiteoria',
    landCatAi: 'Tekoälyn tuottama',
    landSearchCategoryHint: 'Haulla näet kaikki tämän luokan {n} mallia.',
    landNoTemplates: 'Ei malleja haulle "{q}"',
    landCtaTitle: 'Valmis aloittamaan kyselyn?',
    landCtaBody: 'Luo tili ja julkaise ensimmäinen kysely alle kymmenessä minuutissa.',
    landGetStarted: 'Aloita maksutta',
    landPreview: 'Esikatselu',
    landUse: 'Käytä',
    landPaper: 'Artikkeli',
    landDataset: 'Aineisto',
    landChipAi: 'Tekoäly',
    landChipUrban: 'Kaupunki',
    landChipAcademic: 'Akateeminen',
    landPreviewTitle: 'Esikatselu — {name}',
    landReadOnly: '(vain luku)',
    landClose: 'Sulje',
    trialDoNTimes: 'Tämä tehdään {n} kertaa. Tämä on {current} / {n}.',
    trialProgressCount: 'Valmiina {done} / {n}. Jäljellä {left}.',
    trialAutoAdvance: 'Vastauksen jälkeen seuraava kierros alkaa itsestään.',
    trialUseNext: 'Vastattuasi paina Seuraava kierros.',
    trialLastRound: 'Viimeinen kierros — sen jälkeen kysely jatkuu.',
    trialAllDone: 'Kaikki {n} kierrosta on vastattu.',
    trialContinue: 'Seuraavaan kysymykseen',
    trialFinishSurvey: 'Lopeta kysely',
    trialBack: 'Takaisin',
    trialNextRound: 'Seuraava kierros',
    trialPageNextBlocked: 'Tee kaikki kierrokset ennen jatkamista.',
    progressRound: 'Kierros {current} / {n}',
    trialLabel: 'Kierros {n}',
    trialReviewAnswers: 'Tarkista vastaukset',
    progressPage: 'Sivu {current} / {n}',
    progressQuestion: 'Kysymys {current} / {n}',
    progressQuestionLabel: 'Kysymys {n}',
    progressTrialCount: '{done}/{n} kierrosta',
    progressNotReached: 'Ei vielä saavutettu',
    progressJump: '{label} — siirry napsauttamalla',
    progressPreviousGroup: 'Edellinen kysymysryhmä',
    progressNextGroup: 'Seuraava kysymysryhmä',
    participantSaving: 'Vastauksia tallennetaan…',
    participantThanks: 'Kiitos!',
    participantCompleted: 'Kiitos kyselyyn osallistumisesta.',
    participantRoundsCompleted: 'Kaikki {n} merkintäkierrosta on tehty.',
    participantCompletionCode: 'Valmistumiskoodi:',
    participantIdLabel: 'Osallistujatunnuksesi:',
    participantSavedLocally: 'Vastaukset tallennettiin tälle laitteelle.',
    participantSaved: 'Vastaukset tallennettiin.',
    participantSaveError: 'Vastauksia ei voitu tallentaa verkon tai palvelimen vuoksi. Vastaukset ovat tallella — yritä uudelleen.',
    participantRetrySubmission: 'Lähetä uudelleen',
    participantResumeTitle: 'Jatketaanko aiempaa kertaa?',
    participantResumeBody: 'Löysimme keskeneräisen kyselyn ajankohdasta {date}. Jatketaanko siitä, mihin jäit?',
    participantPreviousVisit: 'aiempi käynti',
    participantStartFresh: 'Aloita alusta',
    participantResume: 'Jatka',
    loginBrand: 'Katunäkymien havaintokysely',
    loginSubtitle: 'Tutkijan kirjautuminen',
    loginSignIn: 'Kirjaudu',
    loginCreateAccount: 'Luo tili',
    loginEmail: 'Sähköposti',
    loginPassword: 'Salasana',
    loginPasswordHelp: 'Vähintään 6 merkkiä',
    loginSigningIn: 'Kirjaudutaan…',
    loginCreating: 'Tiliä luodaan…',
    loginRegisterSuccess: 'Rekisteröinti onnistui. Vahvista tili sähköpostista ja kirjaudu sitten.',
    loginErrorGeneric: 'Tapahtui virhe',
    loginBackHome: '← Etusivulle',
    liveTitle: 'Avoimet kyselyt',
    liveBody: 'Alustan esittelemät tutkimukset. Osallistujalinkki noudattaa tutkijan julkaisuasetusta. Harmaat kortit ovat hyväksytyn ajan ulkopuolella.',
    liveEmpty: 'Esittelyssä ei ole vielä kyselyitä. Tutkija voi hakea julkaisua etusivulle projektivalikosta; ylläpito hyväksyy listaukset.',
    liveNowOnline: 'Avoinna ({n})',
    liveUpcomingClosed: 'Tulossa ja suljettu',
    liveOnline: 'Avoinna',
    liveUpcoming: 'Tulossa',
    liveClosed: 'Suljettu',
    liveNoDescription: 'Kuvausta ei ole.',
    liveTakeSurvey: 'Vastaa kyselyyn',
    liveNotOpenYet: 'Ei vielä auki',
    teamTitle: 'Tiimi',
    teamIntroBefore: 'SP-Surveytä johtaa',
    teamIntroMid: 'yksikössä',
    teamIntroAfter: ', National University of Singapore. Yhteistyökumppaneita on muissa laitoksissa, ja Filip Biljecki ohjaa työtä.',
    teamCollaborators: 'Yhteistyökumppanit',
    teamAffiliations: 'Taustaorganisaatiot',
    teamProfile: 'Profiili',
    teamProjectLead: 'Projektin vetäjä',
    teamPI: 'Vastuullinen tutkija',
    teamLeadBlurb: 'Käynnisti ja johtaa SP-Surveyn suunnittelua, kehitystä ja avointa julkaisua.',
    teamPiBlurb: 'Urban Analytics Labin perustaja. Antaa SP-Surveylle tutkimuksellisen ohjauksen.',
    teamRolePhd: 'Tohtoritutkija',
    teamRoleEngineer: 'Tutkimusinsinööri',
    teamRoleFellow: 'Tutkija',
    teamRoleVisiting: 'Vieraileva tutkija',
    teamRoleAssocProf: 'Apulaisprofessori',
    papersTitle: 'Julkaisukirjasto',
    papersCount: '{n} artikkelia',
    papersWithTemplate: '{n} mallilla',
    papersWithTemplateTitle: 'Näytä vain artikkelit, joihin on liitetty kyselymalli',
    papersBody: 'Kaupunkikuvia ja ihmiskyselyitä käsittelevä kirjallisuus, johon tämän alustan mallit nojaavat. Mallin tunniste näkyy, kun ylläpito yhdistää artikkelin malliin.',
    papersAll: 'Kaikki artikkelit',
    papersHasTemplate: 'Malli ({n})',
    papersNoTemplate: 'Ei mallia ({n})',
    papersSearchPlaceholder: 'Otsikko / DOI / julkaisukanava / tekijä / mallin tunniste',
    papersSearch: 'Hae',
    papersClearSearch: 'Tyhjennä haku',
    papersShowing: 'Näytetään {shown} / {total} artikkelia',
    papersHasTemplateSuffix: ' · malli',
    papersNoTemplateSuffix: ' · ei mallia',
    papersNoMatch: 'Ei vastaavia artikkeleita.',
    papersOpen: 'Avaa artikkeli',
    papersColTitle: 'Otsikko',
    papersColYear: 'Vuosi',
    papersColTemplate: 'Malli',
    papersColLink: 'Linkki',
  },
  es: {
    footerDevelopedBy: 'Desarrollado por',
    newsTitle: 'Noticias',
    newsSubtitle: 'Actualizaciones, versiones y notas de investigación de SP-Survey.',
    newsEmpty: 'Aún no hay publicaciones.',
    newsBackToList: 'Todas las noticias',
    newsNotFound: 'No se encontró esta publicación o ya no está publicada.',
    newsNoBody: 'Sin contenido.',
    newsUnavailable: 'Las noticias aún no están disponibles.',
    benchViewLeaderboard: 'Ver clasificación',
    landLiveBannerOne: 'Hay {n} encuesta en curso — puedes responder como participante.',
    landLiveBannerMany: 'Hay {n} encuestas en curso — puedes responder como participante.',
    landBrowseLive: 'Ver encuestas en curso',
    landHeroTitle: 'Encuesta de percepción del paisaje urbano',
    landHeroLine1: 'Una plataforma de investigación para encuestas de percepción visual de paisajes urbanos.',
    landHeroLine2: 'Crea, comparte y analiza estudios de percepción del paisaje urbano, sin programar.',
    landStartFree: 'Empezar gratis →',
    landReadPaper: 'Leer el artículo',
    landFeaturesTitle: 'Lo necesario para una investigación de percepción',
    landFeatUploadTitle: 'Subir imágenes',
    landFeatUploadDesc: 'Sube imágenes de calle directamente a la nube. Se comprimen para que la encuesta cargue rápido.',
    landFeatAiTitle: 'Diseñador de encuestas con IA',
    landFeatAiDesc: 'Describe el objetivo de la investigación y ChatGPT genera la encuesta con tipos de pregunta ya validados.',
    landFeatShareTitle: 'Compartir al instante',
    landFeatShareDesc: 'Obtén un enlace para compartir de inmediato, sin servidor ni despliegue.',
    landFeatResultsTitle: 'Análisis de resultados',
    landFeatResultsDesc: 'Consulta las respuestas por pregunta, emparéjalas con las imágenes y expórtalas a CSV.',
    landTemplatesTitle: 'Biblioteca de plantillas',
    landTemplatesSubtitle: 'Empieza con diseños de encuesta revisados por pares y usados en investigación publicada',
    landRequestTemplate: 'Pedir una plantilla para tu artículo',
    landRequestDesign: 'Pedir ayuda con el diseño',
    landSearchTemplates: 'Buscar por nombre, autor o tema…',
    landCatAcademic: 'Investigación académica',
    landCatUrban: 'Teoría urbana',
    landCatAi: 'Generado con IA',
    landSearchCategoryHint: 'Busca para ver las {n} plantillas de esta categoría.',
    landNoTemplates: 'No hay plantillas para "{q}"',
    landCtaTitle: '¿Listo para empezar tu encuesta?',
    landCtaBody: 'Crea una cuenta y publica tu primera encuesta en menos de 10 minutos.',
    landGetStarted: 'Empezar gratis',
    landPreview: 'Vista previa',
    landUse: 'Usar',
    landPaper: 'Artículo',
    landDataset: 'Conjunto de datos',
    landChipAi: 'IA',
    landChipUrban: 'Urbano',
    landChipAcademic: 'Académico',
    landPreviewTitle: 'Vista previa — {name}',
    landReadOnly: '(solo lectura)',
    landClose: 'Cerrar',
    trialDoNTimes: 'Harás esto {n} veces. Esta es la {current} de {n}.',
    trialProgressCount: 'Completadas {done} / {n}. Quedan {left}.',
    trialAutoAdvance: 'Al responder, la siguiente ronda empieza sola.',
    trialUseNext: 'Después de responder, usa Siguiente ronda.',
    trialLastRound: 'Última ronda; después continúa la encuesta.',
    trialAllDone: 'Respondidas las {n} rondas.',
    trialContinue: 'Siguiente pregunta',
    trialFinishSurvey: 'Terminar la encuesta',
    trialBack: 'Atrás',
    trialNextRound: 'Siguiente ronda',
    trialPageNextBlocked: 'Completa todas las rondas antes de continuar.',
    progressRound: 'Ronda {current} / {n}',
    trialLabel: 'Ronda {n}',
    trialReviewAnswers: 'Revisar respuestas',
    progressPage: 'Página {current} / {n}',
    progressQuestion: 'Pregunta {current} / {n}',
    progressQuestionLabel: 'Pregunta {n}',
    progressTrialCount: '{done}/{n} rondas',
    progressNotReached: 'Aún no alcanzada',
    progressJump: '{label} — clic para ir',
    progressPreviousGroup: 'Grupo de preguntas anterior',
    progressNextGroup: 'Grupo de preguntas siguiente',
    participantSaving: 'Guardando tus respuestas…',
    participantThanks: '¡Gracias!',
    participantCompleted: 'Gracias por completar la encuesta.',
    participantRoundsCompleted: 'Completadas las {n} rondas de anotación.',
    participantCompletionCode: 'Código de finalización:',
    participantIdLabel: 'Tu identificador de participante:',
    participantSavedLocally: 'Respuestas guardadas en este dispositivo.',
    participantSaved: 'Respuestas guardadas.',
    participantSaveError: 'No se pudieron guardar las respuestas por un problema de red o del servidor. Tus respuestas siguen aquí; inténtalo de nuevo.',
    participantRetrySubmission: 'Reintentar envío',
    participantResumeTitle: '¿Continuar la sesión anterior?',
    participantResumeBody: 'Encontramos una encuesta sin terminar de {date}. ¿Quieres seguir donde lo dejaste?',
    participantPreviousVisit: 'una visita anterior',
    participantStartFresh: 'Empezar de nuevo',
    participantResume: 'Continuar',
    loginBrand: 'Encuesta de percepción del paisaje urbano',
    loginSubtitle: 'Acceso de investigadores',
    loginSignIn: 'Entrar',
    loginCreateAccount: 'Crear cuenta',
    loginEmail: 'Correo',
    loginPassword: 'Contraseña',
    loginPasswordHelp: 'Mínimo 6 caracteres',
    loginSigningIn: 'Entrando…',
    loginCreating: 'Creando la cuenta…',
    loginRegisterSuccess: 'Registro correcto. Revisa tu correo para confirmar la cuenta y luego entra.',
    loginErrorGeneric: 'Ocurrió un error',
    loginBackHome: '← Volver al inicio',
    liveTitle: 'Encuestas en curso',
    liveBody: 'Estudios que la plataforma muestra ahora. El enlace de participación sigue la publicación del investigador. Las tarjetas grises están fuera de su horario aprobado.',
    liveEmpty: 'Aún no hay encuestas destacadas. El investigador puede solicitar la publicación en la página principal; un administrador la aprueba.',
    liveNowOnline: 'En curso ({n})',
    liveUpcomingClosed: 'Próximas y cerradas',
    liveOnline: 'En curso',
    liveUpcoming: 'Próxima',
    liveClosed: 'Cerrada',
    liveNoDescription: 'Sin descripción.',
    liveTakeSurvey: 'Responder',
    liveNotOpenYet: 'Aún no abierta',
    teamTitle: 'Equipo',
    teamIntroBefore: 'SP-Survey está dirigido por',
    teamIntroMid: 'en',
    teamIntroAfter: ', Universidad Nacional de Singapur, con colaboradores de otras instituciones y la supervisión de Filip Biljecki.',
    teamCollaborators: 'Colaboradores',
    teamAffiliations: 'Afiliaciones',
    teamProfile: 'Perfil',
    teamProjectLead: 'Responsable del proyecto',
    teamPI: 'Investigador principal',
    teamLeadBlurb: 'Inició y dirige el diseño, el desarrollo y la publicación abierta de SP-Survey.',
    teamPiBlurb: 'Fundador del Urban Analytics Lab; da la dirección académica de SP-Survey.',
    teamRolePhd: 'Investigador doctoral',
    teamRoleEngineer: 'Ingeniero de investigación',
    teamRoleFellow: 'Investigador',
    teamRoleVisiting: 'Investigador visitante',
    teamRoleAssocProf: 'Profesor asociado',
    papersTitle: 'Biblioteca de artículos',
    papersCount: '{n} artículos',
    papersWithTemplate: '{n} con plantilla',
    papersWithTemplateTitle: 'Mostrar solo artículos vinculados a una plantilla',
    papersBody: 'Literatura de imagen urbana y encuestas humanas que sostiene las plantillas de esta plataforma. El identificador de la plantilla aparece cuando un administrador vincula el artículo.',
    papersAll: 'Todos los artículos',
    papersHasTemplate: 'Con plantilla ({n})',
    papersNoTemplate: 'Sin plantilla ({n})',
    papersSearchPlaceholder: 'Título / DOI / revista / autor / id de plantilla',
    papersSearch: 'Buscar',
    papersClearSearch: 'Borrar búsqueda',
    papersShowing: 'Mostrando {shown} / {total} artículos',
    papersHasTemplateSuffix: ' · con plantilla',
    papersNoTemplateSuffix: ' · sin plantilla',
    papersNoMatch: 'No hay artículos coincidentes.',
    papersOpen: 'Abrir artículo',
    papersColTitle: 'Título',
    papersColYear: 'Año',
    papersColTemplate: 'Plantilla',
    papersColLink: 'Enlace',
  },
  fr: {
    footerDevelopedBy: 'Développé par',
    newsTitle: 'Actualités',
    newsSubtitle: 'Mises à jour, versions et notes de recherche de SP-Survey.',
    newsEmpty: 'Aucune publication pour le moment.',
    newsBackToList: 'Toutes les actualités',
    newsNotFound: 'Cette publication est introuvable ou n’est plus en ligne.',
    newsNoBody: 'Aucun contenu.',
    newsUnavailable: 'Les actualités ne sont pas encore disponibles.',
    benchViewLeaderboard: 'Voir le classement',
    landLiveBannerOne: '{n} enquête est en cours — vous pouvez y répondre.',
    landLiveBannerMany: '{n} enquêtes sont en cours — vous pouvez y répondre.',
    landBrowseLive: 'Voir les enquêtes en cours',
    landHeroTitle: 'Enquête sur la perception des paysages de rue',
    landHeroLine1: 'Une plateforme de recherche pour les enquêtes de perception visuelle des paysages urbains.',
    landHeroLine2: 'Créez, partagez et analysez des études de perception des paysages de rue, sans programmer.',
    landStartFree: 'Commencer gratuitement →',
    landReadPaper: 'Lire l’article',
    landFeaturesTitle: 'Ce qu’il faut pour une recherche sur la perception',
    landFeatUploadTitle: 'Importer des images',
    landFeatUploadDesc: 'Importez des images de rue directement dans le nuage. Elles sont compressées pour garder l’enquête rapide.',
    landFeatAiTitle: 'Conception d’enquête avec IA',
    landFeatAiDesc: 'Décrivez l’objectif de recherche. ChatGPT compose l’enquête avec des types de questions déjà éprouvés.',
    landFeatShareTitle: 'Partage immédiat',
    landFeatShareDesc: 'Obtenez un lien à partager tout de suite, sans serveur ni déploiement.',
    landFeatResultsTitle: 'Analyse des résultats',
    landFeatResultsDesc: 'Consultez les réponses par question, associez-les aux images et exportez-les en CSV.',
    landTemplatesTitle: 'Bibliothèque de modèles',
    landTemplatesSubtitle: 'Partez de questionnaires relus par des pairs et déjà utilisés dans des recherches publiées',
    landRequestTemplate: 'Demander un modèle pour votre article',
    landRequestDesign: 'Demander de l’aide pour la conception',
    landSearchTemplates: 'Rechercher par nom, auteur ou sujet…',
    landCatAcademic: 'Recherche académique',
    landCatUrban: 'Théorie urbaine',
    landCatAi: 'Généré par IA',
    landSearchCategoryHint: 'La recherche affiche les {n} modèles de cette catégorie.',
    landNoTemplates: 'Aucun modèle pour « {q} »',
    landCtaTitle: 'Prêt à lancer votre enquête ?',
    landCtaBody: 'Créez un compte et mettez en ligne votre première enquête en moins de 10 minutes.',
    landGetStarted: 'Commencer gratuitement',
    landPreview: 'Aperçu',
    landUse: 'Utiliser',
    landPaper: 'Article',
    landDataset: 'Jeu de données',
    landChipAi: 'IA',
    landChipUrban: 'Urbain',
    landChipAcademic: 'Académique',
    landPreviewTitle: 'Aperçu — {name}',
    landReadOnly: '(lecture seule)',
    landClose: 'Fermer',
    trialDoNTimes: 'Vous ferez ceci {n} fois. Ceci est le passage {current} sur {n}.',
    trialProgressCount: 'Terminés {done} / {n}. Il en reste {left}.',
    trialAutoAdvance: 'Après votre réponse, le passage suivant commence seul.',
    trialUseNext: 'Après avoir répondu, utilisez Passage suivant.',
    trialLastRound: 'Dernier passage, puis l’enquête continue.',
    trialAllDone: 'Les {n} passages sont répondus.',
    trialContinue: 'Question suivante',
    trialFinishSurvey: 'Terminer l’enquête',
    trialBack: 'Retour',
    trialNextRound: 'Passage suivant',
    trialPageNextBlocked: 'Terminez tous les passages avant de continuer.',
    progressRound: 'Passage {current} / {n}',
    trialLabel: 'Passage {n}',
    trialReviewAnswers: 'Revoir les réponses',
    progressPage: 'Page {current} / {n}',
    progressQuestion: 'Question {current} / {n}',
    progressQuestionLabel: 'Question {n}',
    progressTrialCount: '{done}/{n} passages',
    progressNotReached: 'Pas encore atteint',
    progressJump: '{label} — cliquer pour y aller',
    progressPreviousGroup: 'Groupe de questions précédent',
    progressNextGroup: 'Groupe de questions suivant',
    participantSaving: 'Enregistrement de vos réponses…',
    participantThanks: 'Merci !',
    participantCompleted: 'Merci d’avoir terminé l’enquête.',
    participantRoundsCompleted: 'Les {n} passages d’annotation sont terminés.',
    participantCompletionCode: 'Code de fin :',
    participantIdLabel: 'Votre identifiant de participant :',
    participantSavedLocally: 'Réponses enregistrées sur cet appareil.',
    participantSaved: 'Réponses enregistrées.',
    participantSaveError: 'Les réponses n’ont pas pu être enregistrées à cause du réseau ou du serveur. Elles sont conservées — réessayez.',
    participantRetrySubmission: 'Renvoyer',
    participantResumeTitle: 'Reprendre la session précédente ?',
    participantResumeBody: 'Une enquête inachevée du {date} a été trouvée. Reprendre là où vous vous étiez arrêté ?',
    participantPreviousVisit: 'une visite précédente',
    participantStartFresh: 'Recommencer',
    participantResume: 'Reprendre',
    loginBrand: 'Enquête sur la perception des paysages de rue',
    loginSubtitle: 'Connexion chercheur',
    loginSignIn: 'Se connecter',
    loginCreateAccount: 'Créer un compte',
    loginEmail: 'E-mail',
    loginPassword: 'Mot de passe',
    loginPasswordHelp: '6 caractères au minimum',
    loginSigningIn: 'Connexion…',
    loginCreating: 'Création du compte…',
    loginRegisterSuccess: 'Inscription réussie. Confirmez le compte dans votre e-mail, puis connectez-vous.',
    loginErrorGeneric: 'Une erreur s’est produite',
    loginBackHome: '← Retour à l’accueil',
    liveTitle: 'Enquêtes en cours',
    liveBody: 'Études présentées par la plateforme. Le lien suit les réglages de publication du chercheur. Les cartes grises sont hors de la période approuvée.',
    liveEmpty: 'Aucune enquête n’est encore présentée. Le chercheur peut demander la publication sur la page d’accueil ; un administrateur l’approuve.',
    liveNowOnline: 'En cours ({n})',
    liveUpcomingClosed: 'À venir et terminées',
    liveOnline: 'En cours',
    liveUpcoming: 'À venir',
    liveClosed: 'Terminée',
    liveNoDescription: 'Aucune description.',
    liveTakeSurvey: 'Répondre',
    liveNotOpenYet: 'Pas encore ouverte',
    teamTitle: 'Équipe',
    teamIntroBefore: 'SP-Survey est dirigé par',
    teamIntroMid: 'au',
    teamIntroAfter: ', Université nationale de Singapour, avec des collaborateurs d’autres établissements, sous la direction de Filip Biljecki.',
    teamCollaborators: 'Collaborateurs',
    teamAffiliations: 'Affiliations',
    teamProfile: 'Profil',
    teamProjectLead: 'Responsable du projet',
    teamPI: 'Chercheur principal',
    teamLeadBlurb: 'A lancé et dirige la conception, le développement et la publication ouverte de SP-Survey.',
    teamPiBlurb: 'Fondateur de l’Urban Analytics Lab ; il donne la direction scientifique de SP-Survey.',
    teamRolePhd: 'Chercheur doctorant',
    teamRoleEngineer: 'Ingénieur de recherche',
    teamRoleFellow: 'Chercheur',
    teamRoleVisiting: 'Chercheur invité',
    teamRoleAssocProf: 'Professeur associé',
    papersTitle: 'Bibliothèque d’articles',
    papersCount: '{n} articles',
    papersWithTemplate: '{n} avec modèle',
    papersWithTemplateTitle: 'Afficher seulement les articles liés à un modèle',
    papersBody: 'Littérature sur l’imagerie urbaine et les enquêtes humaines, qui fonde les modèles de cette plateforme. L’identifiant du modèle apparaît quand un administrateur relie l’article.',
    papersAll: 'Tous les articles',
    papersHasTemplate: 'Avec modèle ({n})',
    papersNoTemplate: 'Sans modèle ({n})',
    papersSearchPlaceholder: 'Titre / DOI / revue / auteur / id du modèle',
    papersSearch: 'Rechercher',
    papersClearSearch: 'Effacer la recherche',
    papersShowing: '{shown} / {total} articles affichés',
    papersHasTemplateSuffix: ' · avec modèle',
    papersNoTemplateSuffix: ' · sans modèle',
    papersNoMatch: 'Aucun article correspondant.',
    papersOpen: 'Ouvrir l’article',
    papersColTitle: 'Titre',
    papersColYear: 'Année',
    papersColTemplate: 'Modèle',
    papersColLink: 'Lien',
  },
  de: {
    footerDevelopedBy: 'Entwickelt von',
    newsTitle: 'Neuigkeiten',
    newsSubtitle: 'Produktaktualisierungen, Versionen und Forschungsnotizen von SP-Survey.',
    newsEmpty: 'Noch keine Beiträge.',
    newsBackToList: 'Alle Neuigkeiten',
    newsNotFound: 'Dieser Beitrag wurde nicht gefunden oder ist nicht mehr veröffentlicht.',
    newsNoBody: 'Kein Inhalt.',
    newsUnavailable: 'Neuigkeiten sind noch nicht verfügbar.',
    benchViewLeaderboard: 'Rangliste ansehen',
    landLiveBannerOne: '{n} Umfrage ist gerade online — Sie können als Teilnehmende antworten.',
    landLiveBannerMany: '{n} Umfragen sind gerade online — Sie können als Teilnehmende antworten.',
    landBrowseLive: 'Laufende Umfragen ansehen',
    landHeroTitle: 'Umfrage zur Wahrnehmung von Straßenräumen',
    landHeroLine1: 'Eine Forschungsplattform für visuelle Wahrnehmungsumfragen zu städtischen Straßenräumen.',
    landHeroLine2: 'Erstellen, teilen und auswerten Sie Studien zur Straßenraumwahrnehmung — ohne Programmierung.',
    landStartFree: 'Kostenlos starten →',
    landReadPaper: 'Artikel lesen',
    landFeaturesTitle: 'Was eine Wahrnehmungsstudie braucht',
    landFeatUploadTitle: 'Bilder hochladen',
    landFeatUploadDesc: 'Laden Sie Straßenbilder direkt in die Cloud. Sie werden automatisch komprimiert, damit die Umfrage schnell bleibt.',
    landFeatAiTitle: 'KI-Umfrageeditor',
    landFeatAiDesc: 'Beschreiben Sie das Forschungsziel. ChatGPT erstellt die Umfrage mit geprüften Fragetypen.',
    landFeatShareTitle: 'Sofort teilen',
    landFeatShareDesc: 'Sie erhalten sofort einen Link. Server oder Bereitstellung sind nicht nötig.',
    landFeatResultsTitle: 'Ergebnisauswertung',
    landFeatResultsDesc: 'Sehen Sie Antworten je Frage, ordnen Sie sie den Bildern zu und exportieren Sie CSV.',
    landTemplatesTitle: 'Vorlagenbibliothek',
    landTemplatesSubtitle: 'Starten Sie mit begutachteten Umfragedesigns aus veröffentlichten Studien',
    landRequestTemplate: 'Vorlage für Ihren Artikel anfragen',
    landRequestDesign: 'Hilfe beim Umfragedesign anfragen',
    landSearchTemplates: 'Nach Name, Autor oder Thema suchen…',
    landCatAcademic: 'Akademische Forschung',
    landCatUrban: 'Stadttheorie',
    landCatAi: 'KI-erzeugt',
    landSearchCategoryHint: 'Die Suche zeigt alle {n} Vorlagen dieser Kategorie.',
    landNoTemplates: 'Keine Vorlagen für „{q}“',
    landCtaTitle: 'Bereit für Ihre Umfrage?',
    landCtaBody: 'Legen Sie ein Konto an und veröffentlichen Sie die erste Umfrage in unter 10 Minuten.',
    landGetStarted: 'Kostenlos starten',
    landPreview: 'Vorschau',
    landUse: 'Verwenden',
    landPaper: 'Artikel',
    landDataset: 'Datensatz',
    landChipAi: 'KI',
    landChipUrban: 'Stadt',
    landChipAcademic: 'Akademisch',
    landPreviewTitle: 'Vorschau — {name}',
    landReadOnly: '(nur lesen)',
    landClose: 'Schließen',
    trialDoNTimes: 'Dies machen Sie {n}-mal. Dies ist Durchgang {current} von {n}.',
    trialProgressCount: 'Erledigt {done} / {n}. Noch {left}.',
    trialAutoAdvance: 'Nach der Antwort beginnt der nächste Durchgang von selbst.',
    trialUseNext: 'Nach der Antwort Nächster Durchgang verwenden.',
    trialLastRound: 'Letzter Durchgang, danach geht die Umfrage weiter.',
    trialAllDone: 'Alle {n} Durchgänge sind beantwortet.',
    trialContinue: 'Nächste Frage',
    trialFinishSurvey: 'Umfrage beenden',
    trialBack: 'Zurück',
    trialNextRound: 'Nächster Durchgang',
    trialPageNextBlocked: 'Bitte alle Durchgänge abschließen, bevor Sie fortfahren.',
    progressRound: 'Durchgang {current} / {n}',
    trialLabel: 'Durchgang {n}',
    trialReviewAnswers: 'Antworten prüfen',
    progressPage: 'Seite {current} / {n}',
    progressQuestion: 'Frage {current} / {n}',
    progressQuestionLabel: 'Frage {n}',
    progressTrialCount: '{done}/{n} Durchgänge',
    progressNotReached: 'Noch nicht erreicht',
    progressJump: '{label} — zum Springen klicken',
    progressPreviousGroup: 'Vorherige Fragengruppe',
    progressNextGroup: 'Nächste Fragengruppe',
    participantSaving: 'Antworten werden gespeichert…',
    participantThanks: 'Danke!',
    participantCompleted: 'Danke, dass Sie die Umfrage abgeschlossen haben.',
    participantRoundsCompleted: 'Alle {n} Markierungsdurchgänge sind fertig.',
    participantCompletionCode: 'Abschlusscode:',
    participantIdLabel: 'Ihre Teilnehmenden-ID:',
    participantSavedLocally: 'Antworten auf diesem Gerät gespeichert.',
    participantSaved: 'Antworten gespeichert.',
    participantSaveError: 'Die Antworten konnten wegen eines Netz- oder Serverproblems nicht gespeichert werden. Sie bleiben erhalten — bitte erneut versuchen.',
    participantRetrySubmission: 'Erneut senden',
    participantResumeTitle: 'Vorherige Sitzung fortsetzen?',
    participantResumeBody: 'Eine unvollendete Umfrage von {date} wurde gefunden. Dort weitermachen, wo Sie aufgehört haben?',
    participantPreviousVisit: 'einem früheren Besuch',
    participantStartFresh: 'Neu beginnen',
    participantResume: 'Fortsetzen',
    loginBrand: 'Umfrage zur Wahrnehmung von Straßenräumen',
    loginSubtitle: 'Forscheranmeldung',
    loginSignIn: 'Anmelden',
    loginCreateAccount: 'Konto erstellen',
    loginEmail: 'E-Mail',
    loginPassword: 'Passwort',
    loginPasswordHelp: 'Mindestens 6 Zeichen',
    loginSigningIn: 'Anmeldung…',
    loginCreating: 'Konto wird erstellt…',
    loginRegisterSuccess: 'Registrierung erfolgreich. Bitte bestätigen Sie das Konto per E-Mail und melden Sie sich dann an.',
    loginErrorGeneric: 'Ein Fehler ist aufgetreten',
    loginBackHome: '← Zur Startseite',
    liveTitle: 'Laufende Umfragen',
    liveBody: 'Studien, die die Plattform gerade zeigt. Der Teilnahmelink folgt der Veröffentlichung der forschenden Person. Graue Karten liegen außerhalb des freigegebenen Zeitfensters.',
    liveEmpty: 'Noch keine vorgestellten Umfragen. Forschende können die Veröffentlichung auf der Startseite beantragen; die Verwaltung gibt sie frei.',
    liveNowOnline: 'Jetzt online ({n})',
    liveUpcomingClosed: 'Bevorstehend und geschlossen',
    liveOnline: 'Online',
    liveUpcoming: 'Bevorstehend',
    liveClosed: 'Geschlossen',
    liveNoDescription: 'Keine Beschreibung.',
    liveTakeSurvey: 'Teilnehmen',
    liveNotOpenYet: 'Noch nicht geöffnet',
    teamTitle: 'Team',
    teamIntroBefore: 'SP-Survey wird geleitet von',
    teamIntroMid: 'am',
    teamIntroAfter: ', National University of Singapore, mit Partnern anderer Einrichtungen und unter der Leitung von Filip Biljecki.',
    teamCollaborators: 'Mitwirkende',
    teamAffiliations: 'Zugehörigkeiten',
    teamProfile: 'Profil',
    teamProjectLead: 'Projektleitung',
    teamPI: 'Verantwortliche Leitung',
    teamLeadBlurb: 'Hat Entwurf, Entwicklung und offene Veröffentlichung von SP-Survey angestoßen und leitet sie.',
    teamPiBlurb: 'Gründer des Urban Analytics Lab; gibt die wissenschaftliche Richtung für SP-Survey.',
    teamRolePhd: 'Doktorand/in',
    teamRoleEngineer: 'Forschungsingenieur/in',
    teamRoleFellow: 'Wissenschaftliche Mitarbeit',
    teamRoleVisiting: 'Gastwissenschaft',
    teamRoleAssocProf: 'Außerordentliche Professur',
    papersTitle: 'Publikationsbibliothek',
    papersCount: '{n} Artikel',
    papersWithTemplate: '{n} mit Vorlage',
    papersWithTemplateTitle: 'Nur Artikel mit verknüpfter Umfragevorlage zeigen',
    papersBody: 'Literatur zu Stadtbildern und menschlichen Umfragen, auf der die Vorlagen dieser Plattform beruhen. Die Vorlagenkennung erscheint, wenn die Verwaltung einen Artikel verknüpft.',
    papersAll: 'Alle Artikel',
    papersHasTemplate: 'Mit Vorlage ({n})',
    papersNoTemplate: 'Ohne Vorlage ({n})',
    papersSearchPlaceholder: 'Titel / DOI / Zeitschrift / Autor / Vorlagenkennung',
    papersSearch: 'Suchen',
    papersClearSearch: 'Suche löschen',
    papersShowing: '{shown} / {total} Artikel',
    papersHasTemplateSuffix: ' · mit Vorlage',
    papersNoTemplateSuffix: ' · ohne Vorlage',
    papersNoMatch: 'Keine passenden Artikel.',
    papersOpen: 'Artikel öffnen',
    papersColTitle: 'Titel',
    papersColYear: 'Jahr',
    papersColTemplate: 'Vorlage',
    papersColLink: 'Link',
  },
  pt: {
    footerDevelopedBy: 'Desenvolvido por',
    newsTitle: 'Notícias',
    newsSubtitle: 'Atualizações, versões e notas de investigação do SP-Survey.',
    newsEmpty: 'Ainda não há publicações.',
    newsBackToList: 'Todas as notícias',
    newsNotFound: 'Esta publicação não foi encontrada ou já não está publicada.',
    newsNoBody: 'Sem conteúdo.',
    newsUnavailable: 'As notícias ainda não estão disponíveis.',
    benchViewLeaderboard: 'Ver classificação',
    landLiveBannerOne: 'Há {n} inquérito em curso — pode responder como participante.',
    landLiveBannerMany: 'Há {n} inquéritos em curso — pode responder como participante.',
    landBrowseLive: 'Ver inquéritos em curso',
    landHeroTitle: 'Inquérito de perceção da paisagem de rua',
    landHeroLine1: 'Uma plataforma de investigação para inquéritos de perceção visual de paisagens urbanas.',
    landHeroLine2: 'Crie, partilhe e analise estudos de perceção da paisagem de rua, sem programar.',
    landStartFree: 'Começar grátis →',
    landReadPaper: 'Ler o artigo',
    landFeaturesTitle: 'O que é preciso para investigação de perceção',
    landFeatUploadTitle: 'Carregar imagens',
    landFeatUploadDesc: 'Carregue imagens de rua diretamente para a nuvem. São comprimidas para o inquérito abrir depressa.',
    landFeatAiTitle: 'Criador de inquéritos com IA',
    landFeatAiDesc: 'Descreva o objetivo da investigação e o ChatGPT gera o inquérito com tipos de pergunta já validados.',
    landFeatShareTitle: 'Partilha imediata',
    landFeatShareDesc: 'Obtenha uma ligação para partilhar de imediato, sem servidor nem publicação técnica.',
    landFeatResultsTitle: 'Análise de resultados',
    landFeatResultsDesc: 'Veja as respostas por pergunta, associe-as às imagens e exporte para CSV.',
    landTemplatesTitle: 'Biblioteca de modelos',
    landTemplatesSubtitle: 'Comece com desenhos de inquérito revistos por pares e usados em investigação publicada',
    landRequestTemplate: 'Pedir um modelo para o seu artigo',
    landRequestDesign: 'Pedir ajuda com o desenho',
    landSearchTemplates: 'Pesquisar por nome, autor ou tema…',
    landCatAcademic: 'Investigação académica',
    landCatUrban: 'Teoria urbana',
    landCatAi: 'Gerado por IA',
    landSearchCategoryHint: 'A pesquisa mostra os {n} modelos desta categoria.',
    landNoTemplates: 'Nenhum modelo para "{q}"',
    landCtaTitle: 'Pronto para começar o inquérito?',
    landCtaBody: 'Crie uma conta e publique o primeiro inquérito em menos de 10 minutos.',
    landGetStarted: 'Começar grátis',
    landPreview: 'Pré-visualizar',
    landUse: 'Usar',
    landPaper: 'Artigo',
    landDataset: 'Conjunto de dados',
    landChipAi: 'IA',
    landChipUrban: 'Urbano',
    landChipAcademic: 'Académico',
    landPreviewTitle: 'Pré-visualização — {name}',
    landReadOnly: '(só leitura)',
    landClose: 'Fechar',
    trialDoNTimes: 'Vai fazer isto {n} vezes. Esta é a {current} de {n}.',
    trialProgressCount: 'Concluídas {done} / {n}. Faltam {left}.',
    trialAutoAdvance: 'Depois da resposta, a ronda seguinte começa sozinha.',
    trialUseNext: 'Depois de responder, use Ronda seguinte.',
    trialLastRound: 'Última ronda — depois o inquérito continua.',
    trialAllDone: 'Todas as {n} rondas foram respondidas.',
    trialContinue: 'Pergunta seguinte',
    trialFinishSurvey: 'Terminar o inquérito',
    trialBack: 'Voltar',
    trialNextRound: 'Ronda seguinte',
    trialPageNextBlocked: 'Conclua todas as rondas antes de continuar.',
    progressRound: 'Ronda {current} / {n}',
    trialLabel: 'Ronda {n}',
    trialReviewAnswers: 'Rever respostas',
    progressPage: 'Página {current} / {n}',
    progressQuestion: 'Pergunta {current} / {n}',
    progressQuestionLabel: 'Pergunta {n}',
    progressTrialCount: '{done}/{n} rondas',
    progressNotReached: 'Ainda não alcançada',
    progressJump: '{label} — clique para ir',
    progressPreviousGroup: 'Grupo de perguntas anterior',
    progressNextGroup: 'Grupo de perguntas seguinte',
    participantSaving: 'A guardar as suas respostas…',
    participantThanks: 'Obrigado!',
    participantCompleted: 'Obrigado por concluir o inquérito.',
    participantRoundsCompleted: 'Concluídas as {n} rondas de anotação.',
    participantCompletionCode: 'Código de conclusão:',
    participantIdLabel: 'O seu identificador de participante:',
    participantSavedLocally: 'Respostas guardadas neste dispositivo.',
    participantSaved: 'Respostas guardadas.',
    participantSaveError: 'Não foi possível guardar as respostas por um problema de rede ou do servidor. As respostas mantêm-se — tente outra vez.',
    participantRetrySubmission: 'Tentar enviar de novo',
    participantResumeTitle: 'Retomar a sessão anterior?',
    participantResumeBody: 'Encontrámos um inquérito por concluir de {date}. Quer continuar de onde parou?',
    participantPreviousVisit: 'uma visita anterior',
    participantStartFresh: 'Começar de novo',
    participantResume: 'Retomar',
    loginBrand: 'Inquérito de perceção da paisagem de rua',
    loginSubtitle: 'Entrada de investigador',
    loginSignIn: 'Entrar',
    loginCreateAccount: 'Criar conta',
    loginEmail: 'E-mail',
    loginPassword: 'Palavra-passe',
    loginPasswordHelp: 'Mínimo de 6 caracteres',
    loginSigningIn: 'A entrar…',
    loginCreating: 'A criar a conta…',
    loginRegisterSuccess: 'Registo concluído. Confirme a conta no e-mail e depois entre.',
    loginErrorGeneric: 'Ocorreu um erro',
    loginBackHome: '← Voltar ao início',
    liveTitle: 'Inquéritos em curso',
    liveBody: 'Estudos apresentados pela plataforma. A ligação de participação segue a publicação do investigador. Os cartões cinzentos estão fora do período aprovado.',
    liveEmpty: 'Ainda não há inquéritos em destaque. O investigador pode pedir a publicação na página principal; um administrador aprova.',
    liveNowOnline: 'Em curso ({n})',
    liveUpcomingClosed: 'Em breve e encerrados',
    liveOnline: 'Em curso',
    liveUpcoming: 'Em breve',
    liveClosed: 'Encerrado',
    liveNoDescription: 'Sem descrição.',
    liveTakeSurvey: 'Responder',
    liveNotOpenYet: 'Ainda não aberto',
    teamTitle: 'Equipa',
    teamIntroBefore: 'O SP-Survey é liderado por',
    teamIntroMid: 'no',
    teamIntroAfter: ', Universidade Nacional de Singapura, com colaboradores de outras instituições e a supervisão de Filip Biljecki.',
    teamCollaborators: 'Colaboradores',
    teamAffiliations: 'Afiliações',
    teamProfile: 'Perfil',
    teamProjectLead: 'Responsável do projeto',
    teamPI: 'Investigador principal',
    teamLeadBlurb: 'Iniciou e lidera o desenho, o desenvolvimento e a publicação aberta do SP-Survey.',
    teamPiBlurb: 'Fundador do Urban Analytics Lab; dá a direção científica do SP-Survey.',
    teamRolePhd: 'Investigador de doutoramento',
    teamRoleEngineer: 'Engenheiro de investigação',
    teamRoleFellow: 'Investigador',
    teamRoleVisiting: 'Investigador visitante',
    teamRoleAssocProf: 'Professor associado',
    papersTitle: 'Biblioteca de artigos',
    papersCount: '{n} artigos',
    papersWithTemplate: '{n} com modelo',
    papersWithTemplateTitle: 'Mostrar só artigos ligados a um modelo de inquérito',
    papersBody: 'Literatura de imagem urbana e inquéritos humanos que fundamenta os modelos desta plataforma. O identificador do modelo aparece quando um administrador liga o artigo.',
    papersAll: 'Todos os artigos',
    papersHasTemplate: 'Com modelo ({n})',
    papersNoTemplate: 'Sem modelo ({n})',
    papersSearchPlaceholder: 'Título / DOI / revista / autor / id do modelo',
    papersSearch: 'Pesquisar',
    papersClearSearch: 'Limpar pesquisa',
    papersShowing: 'A mostrar {shown} / {total} artigos',
    papersHasTemplateSuffix: ' · com modelo',
    papersNoTemplateSuffix: ' · sem modelo',
    papersNoMatch: 'Nenhum artigo correspondente.',
    papersOpen: 'Abrir artigo',
    papersColTitle: 'Título',
    papersColYear: 'Ano',
    papersColTemplate: 'Modelo',
    papersColLink: 'Ligação',
  },
};

export const localePublic = landing;
